import * as actionTypes from "./actionTypes";
import * as ImmersionGQL from "../../gql";

export const getLiveParticipantsSuccess = (res: any) => ({
    type: actionTypes.GET_LIVE_PARTICIPANTS,
    payload: res,
});

export const initLiveParticipantData = () => ({
    type: actionTypes.INITI_LIVE_PARTICIPANT_DATA,
});

export const getLiveSessionParticipants = (client: any, req: any, cb?: any) => {
    return (dispatch: any) => {
      client.query({
        query: ImmersionGQL.queryGetSessionParticipants,
        fetchPolicy: "no-cache",
        variables: { session_code: req.session_code }
      })
        .then((response: any) => {
          if (response.data.getSessionParticipants) {
            const responsedata = response.data.getSessionParticipants;
            dispatch(getLiveParticipantsSuccess(responsedata));
            cb && cb(response.data.getSessionParticipants);
          }
        })
        .catch(() => {});
    };
  };